import type { Style } from 'inlines'

export type TypographyVariant =
  | 'large'
  | 'medium'
  | 'small'
  | 'extraSmall'
  | 'subtitle'

export type TypographyConfig = {
  fontSize: string
  lineHeight?: string
  fontWeight?: number
  isBoldFontWeight?: number
  marginBottom?: string
}

export const typographyStyles: Record<TypographyVariant, TypographyConfig> = {
  large: {
    fontSize: '1.5rem',
    lineHeight: '140%',
    isBoldFontWeight: 700,
    marginBottom: '2rem',
  },
  medium: {
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
    marginBottom: '1.5rem',
  },
  small: {
    fontSize: '0.875rem',
    lineHeight: '1.375rem',
    marginBottom: '1.5rem',
  },
  extraSmall: {
    fontSize: '0.75rem',
  },
  subtitle: {
    fontSize: '1rem',
  },
}

export type TitleLevel = 1 | 2 | 3 | 4 | 5

export const sharedTitleStyles: Style = {
  fontFamily: 'FunnelDisplay',
  fontWeight: '700',
  fontStyle: 'normal',
  marginTop: 0,
}

type TitleLevelStyleConfig = {
  fontSize: string
  lineHeight: string
  marginBottom: string
  letterSpacing?: string
}

const titleLevelStylesDesktop: Record<TitleLevel, TitleLevelStyleConfig> = {
  1: { fontSize: '5.625rem', lineHeight: '100%', marginBottom: '1.5rem' },
  2: { fontSize: '3rem', lineHeight: '100%', marginBottom: '1.5rem' },
  3: {
    fontSize: '2rem',
    lineHeight: '130%',
    marginBottom: '1rem',
    letterSpacing: '-0.02rem',
  },
  4: { fontSize: '1.75rem', lineHeight: '100%', marginBottom: '1rem' },
  5: {
    fontSize: '1.125rem',
    lineHeight: '120%',
    marginBottom: '1rem',
    letterSpacing: '-0.01125rem',
  },
}

const titleLevelStylesMobile: Record<TitleLevel, TitleLevelStyleConfig> = {
  1: { fontSize: '3rem', lineHeight: '130%', marginBottom: '1.5rem' },
  2: { fontSize: '2rem', lineHeight: '130%', marginBottom: '1.5rem' },
  3: {
    fontSize: '1.75rem',
    lineHeight: '110%',
    marginBottom: '1rem',
    letterSpacing: '-0.02rem',
  },
  4: { fontSize: '1.375rem', lineHeight: '110%', marginBottom: '1rem' },
  5: {
    fontSize: '1.125rem',
    lineHeight: '110%',
    marginBottom: '1rem',
    letterSpacing: '-0.01125rem',
  },
}

export const getTitleLevelStyle = (
  level: TitleLevel,
  isMobile: boolean,
): Style => ({
  ...sharedTitleStyles,
  ...(isMobile
    ? titleLevelStylesMobile[level]
    : titleLevelStylesDesktop[level]),
})
